angular.module('bmsApp.trugreen').factory('TGRouteSvc', function ($q,
																	CRUDSvc) {

	var self = {
		index: function (params) {
			return CRUDSvc.get('api/trugreen/route/index', params);
		},
		save: function(params) {
			return CRUDSvc.post('api/trugreen/route/save', params);
		}

	};
	return self;

});
